export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json, text/plain, application/vnd.imggaming.dde.api+json;version=1'
}

export const DEFAULT_REQUEST_OPTIONS: RequestInit = {
  mode: 'cors'
}

export enum API_METHODS {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE'
}
